import { GOOGLE_MAPS_CONFIG } from "../config/googleMaps";

export const ORGANIZATION_LOCATION_LIBRARIES = GOOGLE_MAPS_CONFIG.libraries;

export const ALLOWED_LOGO_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];

export const ALLOWED_LOGO_EXTENSIONS = [".png", ".jpg", ".jpeg", ".webp"];
